var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMHat2WHair3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "w-hair3_1_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M240,204c-22,16-43.5,28.6-41,78c-5.5,4.5-7.5,7.5-10.5,10.8c-6,6.6-10.4,14.9-12.6,22.7 c-7.6-7.9-22.2-11.9-32.8-8.6c0-10.2,5.5-24.1,9.3-33.7c3.8-9.7,7-19.8,11.1-29.5c2-4.8,4.3-9.5,6.9-14.1 c5.2-10.1,13.2-17.1,21.6-24.8c4.4-3.6,9.1-6.7,14-9.4s9.9-4.9,15-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M445.5,204.5c7,1.5,23.5,6,28.8,8.3c44.7,18.6,85.2,80.6,59.2,126.7c21.6-11.9,50.7-33.4,59.5-57 c8.4-22.4,12-49,10.5-72.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M180,304.5l-49-5.5c-0.2,1.1-0.3,2.3-0.5,3.5c8.2,20.1,19.6,39.4,37.3,51.6c2.3-5.7,7.5-14,7.7-19.5 C175.5,330,175,314,180,304.5z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D0E09B",
    d: "M136.5,314.5c-17.9-20.8-19.4-67.3-16-94c5.6-43.5,22.9-78.7,49.7-114.2c50.5-66.6,141-94,222.3-91.8 c107.3,2.9,203.5,87.4,211,195.5c2.5,36.5-4,62.5-20,87.5c-5.8-27.9-56-69.4-81-77c-16.9-5.2-18.4-6.5-29.2-20.7 c-9.2-12-20.4-22.6-33.8-28.2c-58.7-24.3-145.9-27.8-196.7,17.2c-7.1,6.3-32,26.4-33.3,32.7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "hats_w-hair3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "m-hat2_3_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9C29B",
    d: "M513.4,196.7c3.8-4.3,18.8-18.2,12.5-22.5c-92.7-16.3-188.6-19.7-282.7-7.3c-12.4,1.6-24.8,3.4-37.1,5.6 c-7,1.4-14,2.8-20.9,4.5c-1.6,4.2,4.6,11.4,6.8,14.1c4.2,5,8.5,10.4,13.3,14.9c5.3,5,12,9.4,18.4,9.4 c85.6-20.2,176.6-19.3,264-3.5C499.2,211.2,506.4,204.5,513.4,196.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3A77C",
    d: "M232.7,168.2c-8.9,1.2-17.8,2.6-26.6,4.2c-7,1.4-14,2.8-20.9,4.5c-1.6,4.2,4.6,11.4,6.8,14.1 c4.2,5,8.5,10.4,13.3,14.9c5.3,5,12,9.4,18.4,9.4c31.1-7.3,62.8-11.9,94.9-13.9C287.3,196.5,255.2,188.5,232.7,168.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E9C29B",
    d: "M238.7,80.7c-9.4,25.6-16.2,61.2-17,89.2c7.2-1.1,14.3-2.1,21.5-3c82-10.8,165.3-9.6,246.7,1.7 c-2.7-32.9-8.3-65.2-19.1-95.7C409.6,56,309,50.1,238.7,80.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D3A77C",
    d: "M238.7,80.7c-7.6,20.7-13.4,47.8-15.9,72.2c11.1-2.3,22.5-4.4,34-6.1c0.1-25.2,4.2-54.6,10.1-76 C257.2,73.5,247.7,76.8,238.7,80.7z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A110C",
    d: "M222.8,152.9c-0.6,5.9-1,11.6-1.1,17c7.2-1.1,14.3-2.1,21.5-3c82-10.8,165.3-9.6,246.7,1.7 c-0.4-5.2-0.9-10.4-1.5-15.5C407.8,134.8,306.8,135.1,222.8,152.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#947D70",
    d: "M442.2,144.8c-7.9-1-15.8-1.9-23.9-2.7l0.9,19.1c8,0.5,16.1,1.1,24.1,1.9L442.2,144.8z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMHat2WHair3);
export default __webpack_public_path__ + "static/media/m-hat2_w-hair3.7b25ec6ce500fd50e11cb1b7efd7d003.svg";
export { ForwardRef as ReactComponent };